import React from 'react';
import BackButton from './BackButton';

/**
 * Shared page header component for all amendment pages
 * Displays back button, title, and subtitle in a consistent format
 *
 * @param {string} title - Main page title (e.g., "Manage Benefits")
 * @param {string} subtitle - Subtitle or description text
 * @param {Function} onBack - Handler for back button click
 */
const AmendmentPageHeader = ({ title, subtitle, onBack }) => {
  return (
    <div style={{
      marginBottom: '30px',
      paddingBottom: '20px',
      borderBottom: '2px solid #e0e0e0'
    }}>
      {/* Back Button - Top Right */}
      <BackButton onClick={onBack} />

      <h1 style={{ fontSize: '26px', fontWeight: 'bold', marginBottom: '8px', color: '#032A37' }}>
        {title}
      </h1>
      <p style={{ color: '#666', fontSize: '14px', margin: 0 }}>
        {subtitle}
      </p>
    </div>
  );
};

export default AmendmentPageHeader;
